import type { BadgeProps } from './Badge.types';
import './Badge.scss';

export default function Badge({
  variant = 'neutral', size = 'md', iconLeft, className, children, ...rest
}: BadgeProps) {
  return (
    <span
      className={['badge', `badge--${variant}`, `badge--${size}`, className || ''].filter(Boolean).join(' ')}
      {...rest}
    >
      {iconLeft ? <span className="badge__icon" aria-hidden="true">{iconLeft}</span> : null}
      <span className="badge__label">{children}</span>
    </span>
  );
}
